import { render, staticRenderFns } from "./PlanChanges.vue?vue&type=template&id=47e5f785&scoped=true&"
import script from "./PlanChanges.vue?vue&type=script&lang=js&"
export * from "./PlanChanges.vue?vue&type=script&lang=js&"
import style0 from "./PlanChanges.vue?vue&type=style&index=0&id=47e5f785&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e5f785",
  null
  
)

component.options.__file = "PlanChanges.vue"
export default component.exports